import { UiLoaderAnimationVanilla } from '../../Loaders/UiLoaderAnimation/UiLoaderAnimationVanilla'

const getClassName = (className, needClass) => {
  return needClass ? className : ''
}

const getButtonClassList = ({ theme, size, icon, iconPosition, sizeMode, stretchMode, stretch, isLoading }) => {
  return `ui-button
    ui-button--${theme}
    ui-button--${size}
    ${getClassName(`ui-button--icon ui-button--icon-${iconPosition}`, icon)}
    ${getClassName(`ui-button--${sizeMode}`, sizeMode)}
    ${getClassName(`ui-button--stretch-${stretchMode}`, stretchMode)}
    ${getClassName('ui-button--stretch', stretch)}
    ${getClassName('ui-button--loading', isLoading)}
  `
}

const getIconClassList = ({ size, iconPosition }) => {
  return `ui-button__icon
    ui-button__icon--${size}
    ${getClassName(`ui-button__icon--${iconPosition}`, iconPosition)}
  `
}

const getIconTemplate = ({ icon, iconClassList }) => {
  return `<svg class="${iconClassList}" aria-hidden="true">
    <use href="#${icon}"></use>
  </svg>`
}

const getInnerTemplate = ({ title, icon, size, iconClassList, isLoading = false }) => {
  return `${icon ? getIconTemplate({ icon, iconClassList }) : ''}

    <span class="ui-button__text">
      ${title}
    </span>

    ${isLoading ? UiLoaderAnimationVanilla({ classes: `ui-button__loader ui-button__loader--${size}` }) : ''}`
}

const getLinkTemplate = ({ title, href, icon, size, iconClassList, buttonClassList, attrs, classes }) => {
  return `<a
    class="${buttonClassList} ${classes}"
    href="${href}"
    ${attrs}
  >
    ${getInnerTemplate({ title, icon, size, iconClassList })}
  </a>`
}

const getNotInteractiveTemplate = ({ title, icon, iconClassList, buttonClassList, attrs, classes }) => {
  return `<span
    class="${buttonClassList} ${classes}"
    ${attrs}
  >
    ${getInnerTemplate({ title, icon, iconClassList })}
  </span>`
}

const getButtonTemplate = ({ title, type, icon, iconClassList, buttonClassList, attrs, classes }) => {
  return `<button
    class="${buttonClassList} ${classes}"
    type="${type}"
    ${attrs}
  >
    ${getInnerTemplate({ title, icon, iconClassList })}
  </button>`
}

export const UiButtonVanilla = (
  {
    title = '',
    type = 'button',
    href = null,
    theme = 'filled-main',
    size = 'small',
    sizeMode = null,
    stretch = false,
    stretchMode = null,
    icon = null,
    iconPosition = 'left',
    notInteractive = false,
    isLoading = false,
    classes = '',
    attrs = ''
  }
) => {
  const buttonClassList = getButtonClassList({ theme, size, icon, iconPosition, sizeMode, stretchMode, stretch, isLoading })
  const iconClassList = getIconClassList({ size, iconPosition })
  const options = { title, href, type, icon, iconClassList, buttonClassList, attrs, classes }

  if (href) {
    return getLinkTemplate(options)
  } else if (notInteractive) {
    return getNotInteractiveTemplate(options)
  } else {
    return getButtonTemplate(options)
  }
}
